import React from 'react'
import { Table, Card } from 'react-bootstrap'
import { MobileDeviceInfo } from 'interfaces/mobile-device-info'

const UserDeviceInfos = ({
  mobileDeviceInfos = [],
  isLoading,
}: {
  mobileDeviceInfos?: MobileDeviceInfo[]
  isLoading?: boolean
}) => {
  return (
    <Card className="mt-1`">
      <Card.Body>
        {isLoading && <Card.Text>Loading....</Card.Text>}
        {mobileDeviceInfos?.length > 0 && (
          <div
            style={{
              overflowY: 'auto',
              overflowX: 'auto',
              maxHeight: '400px',
              width: '100%',
            }}
          >
            <div style={{ minWidth: '800px' }}>
              <DeviceTable mobileDeviceInfos={mobileDeviceInfos} />
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  )
}
export default UserDeviceInfos

const DeviceTable = ({
  mobileDeviceInfos = [],
}: {
  mobileDeviceInfos: MobileDeviceInfo[]
}) => {
  return (
    <Table responsive variant="dark" className="modern-table">
      <thead>
        <tr className="modern-table-header-row">
          <th className="modern-table-header-cell">Model</th>
          <th className="modern-table-header-cell">Platform</th>
          <th className="modern-table-header-cell">App Version</th>
          <th className="modern-table-header-cell">Operating System</th>
          <th className="modern-table-header-cell">Browser</th>
          <th className="modern-table-header-cell">Browser Version</th>
        </tr>
      </thead>

      <tbody>
        {mobileDeviceInfos?.map((device, index) => (
          <tr
            key={device.id}
            className={
              index === 0 ? 'modern-table-first-row' : 'modern-table-row-border'
            }
          >
            <td className="modern-table-body-cell">{device.model}</td>
            <td className="modern-table-body-cell">{device.platform}</td>
            <td className="modern-table-body-cell">
              {device.platform !== 'web' ? device.app_version : 'n/a'}
            </td>
            <td className="modern-table-body-cell">
              {device.operating_system}
            </td>
            <td className="modern-table-body-cell">
              {device.browser ? device.browser : 'n/a'}
            </td>
            <td className="modern-table-body-cell">
              {device.browser_version ? device.browser_version : 'n/a'}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
